import o from "./HeaderListbox.vue2.js";
import t from "../../_virtual/_plugin-vue_export-helper.js";
const d = /* @__PURE__ */ t(o, [["__scopeId", "data-v-11addf26"]]);
export {
  d as default
};
